/* Worelli — barra de anuncios animada + sello de garantia sobre el hero */
(function () {
  var ROTATE_MS = 4200;

  function build(scope) {
    var root = scope || document;
    var bar = root.querySelector('.w-ann');
    if (!bar || bar.classList.contains('w-ann-v2')) return;

    var inner = bar.querySelector('.w-ann-inner');
    if (!inner) return;

    var links = inner.querySelectorAll('a');
    if (!links.length) return;

    var shopHref = links[0].getAttribute('href') || '/';
    var guaranteeHref = (links[2] && links[2].getAttribute('href')) || shopHref;

    bar.classList.add('w-ann-v2');
    inner.innerHTML =
      '<div class="w-ann-stage">' +
        '<a class="w-ann-slide w-slide-offer is-live" href="' + shopHref + '">' +
          '<span class="w-ann-chip">Limited offer</span>' +
          '<span class="w-ann-copy">2-Pack for <b>$34.99</b> <s>$49.99</s><span class="w-ann-save">Save $15</span></span>' +
        '</a>' +
        '<a class="w-ann-slide w-slide-ship" href="' + shopHref + '">' +
          '<span class="w-ann-truck" aria-hidden="true"></span>' +
          '<span class="w-ann-ship-copy">Free Shipping on Your First Order</span>' +
        '</a>' +
      '</div>';

    var slides = inner.querySelectorAll('.w-ann-slide');
    if (slides.length > 1) {
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-live');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-live');
      }, ROTATE_MS);
    }

    var imgWrap = root.querySelector('.w-hp-hero-img');
    if (imgWrap && !imgWrap.querySelector('.w-hero-guarantee')) {
      var badge = document.createElement('a');
      badge.className = 'w-hero-guarantee';
      badge.setAttribute('href', guaranteeHref);
      badge.innerHTML =
        '<span class="w-hg-icon" aria-hidden="true"></span>' +
        '<span class="w-hg-txt"><b>30-Day Guarantee</b><em>Free returns, no questions asked</em></span>';
      imgWrap.appendChild(badge);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { build(document); });
  } else {
    build(document);
  }
  document.addEventListener('shopify:section:load', function (e) { build(e.target); });
})();
